import { atom } from "jotai";

/* Utility to create a Jotai atom with a debug label for easier debugging in React/Jotai DevTools.
Usage:
import { atomWithDebugLabel } from './atomWithDebugLabel';
const myAtom = atomWithDebugLabel(0, 'myAtom');

With atomFamily:
import { atomFamily } from 'jotai/utils';
const myAtomFamily = atomFamily((key: string) => atomWithDebugLabel(false, `myAtomFamily(${key})`));
*/
export function atomWithDebugLabel<T>(initialValue: T, label: string) {
  const baseAtom = atom(initialValue);
  baseAtom.debugLabel = label;
  return baseAtom;
}
